import React from "react";
import { getSessionStats } from "../services/monitorService";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";

export default function FirestoreAdminStatusBar() {
  const { collectionName, rows, selected, totalCount } = useFirestoreAdmin();
  const session = getSessionStats();

  return (
    <footer className="fa-status-bar">
      <span>Collection: <strong>{collectionName}</strong></span>
      <span>Loaded: {rows.length.toLocaleString()} / {totalCount.toLocaleString()}</span>
      <span>Selected: {selected.size}</span>
      <span>Session reads: {session.reads}</span>
      <span>Session writes: {session.writes}</span>
      <span>Session deletes: {session.deletes}</span>
    </footer>
  );
}
